<template>
    <div>
        <div v-if="stage == 'forget-password'">
            <TopBar
                :label="lbl.topbar.label.login"
                :isRegister="true" />
            <div class="bg">
                <div class="pt-forgetpassword ">
                    <FormForgetPassword @update="openOtpModal($event)"></FormForgetPassword>
                </div>
                <!-- <div class="forget-mobile pt-4 text-center">
                    <div>
                        <span class="link-text" @click="gotoLogin()"> Login</span>
                        or
                        <span class="link-text" @click="gotoSignUp()"> Sign Up </span>
                    </div>
                </div> -->
            </div>
        </div>
        <div v-else>
            <CreateNewPassword
                @submit="changePassword($event)"
            ></CreateNewPassword>
        </div>
        <Footer />
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
//component
import TopBar from '@/components/Layout/TopBar/TopbarSignUp.vue';
import Footer from '@/components/Layout/Footer/Footer.vue';
import FormForgetPassword from '../component/FormForgetPassword.vue';
import CreateNewPassword from '@/module/ForgotPassword/page/CreateNewPassword.vue'
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//helper
import Account from '@/helper/AccountHelper'

//service
import BzbsAuth from "@/core/Account/service/BzbsAuth.js";
import BzbsOtp from "@/core/Otp/service/BzbsOtp.js";

export default {
    name: 'ForgetPassword',
    mixins: [ModalMixin, LocaleMixin],
    components:{
        TopBar,
        Footer,
        FormForgetPassword,
        CreateNewPassword
    },
    data() {
        return {
            stage: 'forget-password'
        };
    },

    mounted() {

    },

    methods: {
        openOtpModal: function(phone){
            console.log(phone)
            //set loadingModal & alertModal
            this.modalController.otpModal.setLoadingModal(this.modalController.loadingModal);
            this.modalController.otpModal.setAlertModal(this.modalController.alertModal);
            //start otp
            this.modalController.otpModal.startOtp(phone, 'forget_password');
            this.modalController.otpModal.onSubmitOtp(async (otp)=>{
                console.log(otp)
                let success = await this.validateOtpApi(otp.tel , otp.refcode , otp.otp , 'forget_password')
                if(success){
                    this.otp = otp;
                    this.stage = 'create-new-password'
                    this.modalController.otpModal.hide();
                }
            })
        },
        gotoLogin: function(){
            this.$router.push('/login')
        },
        gotoSignUp: function(){
            this.$router.push('/register')
        },
        changePassword: function(data) {
            console.log(data.confirmpassword, this.otp)
            return new Promise((resolve) => {
                BzbsAuth.apiB2BChangePassword(data.confirmpassword, this.otp).subscribe((data) => {
                    this.refcode = data.refcode;
                    this.updatePasswordSuccess()
                    resolve(true);
                }, (err) => {
                    console.log(err)
                    if(err.code == 409 && err.id == 2021) {
                        this.modalController.alertModal
                        .clearModal()
                        .setTitle(this.lbl.register.change_password.error.title)
                        .setMsg(this.lbl.register.change_password.error.msg)
                        .show()
                    } else {
                        this.modalController.alertModal
                        .clearModal()
                        .setTitle('Error')
                        .setMsg(err.message)
                        .show()
                    }
                    resolve(false);
                });
            });
        },
        updatePasswordSuccess: function() {
            this.modalController.alertModal
                .clearModal()
                .setTitle(this.lbl.register.change_password.succress.title)
                .setMsg(this.lbl.register.change_password.succress.msg)
                .setBtnOk(this.lbl.register.change_password.succress.btn)
                .show()
            this.modalController.alertModal.onClickOk(()=>{
                this.$router.push('/login')
            })
        },
        validateOtpApi: function(tel,refcode,otp,channel){
            let token = Account.getToken();
            this.modalController.loadingModal.show();
            return new Promise((resolve) => {
                BzbsOtp.validateOtp(token, tel, refcode, otp, channel).subscribe((data) => {
                    console.log(data);
                    this.modalController.loadingModal.hide();
                    resolve(true);
                }, (err) => {
                    if(err.id == 2091 && err.code == 409){
                        this.modalController.otpModal.showError(tel,refcode)
                        this.modalController.otpModal.show();
                    }else{
                        this.modalController.alertModal
                        .clearModal()
                        .setTitle('Error')
                        .setMsg(err.message)
                        .show()
                    }
                    this.modalController.loadingModal.hide();
                    resolve(false);
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/style/base/base.scss';
.forget-mobile {
    color: $a-black-4a4a4a;
        @include min-desktop {
            display: none;
        }
    }

.forget-desktop {
        @include tablet {
            display: none;
        }
        @include max-mobile {
            display: none;
        }
}

.link-text{
    color: $main-orange-color;
    text-decoration: underline;
}
.pt-forgetpassword{
    padding: {
        left: 20px;
        right: 20px;
        top: 70px;
        bottom: 150px;
    }
}
.bg{
    background-color: #f4f4f4;
    //background-image: url('../../../assets/bg/background.svg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    //min-height: calc(100vh - 50px);
    position: relative;
        // @include max-mobile {
        //     background-image: url('../../../assets/bg/bzbs-b2b-background-mobile.svg');
        //     background-size: cover;
        //     background-position: 100% 0;
        //     background-repeat: no-repeat;
        //     min-height: calc(100vh - 50px);
        //     position: relative;
        //     padding-bottom: 77px;
        // }
}
.logo-bottom{
    position: absolute;
    bottom: 30px;
    width: 100%;
    display: flex;
}
</style>
